import { render, staticRenderFns } from "./wdm_article.vue?vue&type=template&id=780e1206"
import script from "./wdm_article.vue?vue&type=script&lang=js"
export * from "./wdm_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports